import React from "react";
import styled from "styled-components";

const ContactUs = () => {
  return (
    <PageWrapper>
      <ContactContainer>
        {/* LEFT INFO PANEL */}
        <InfoPanel>
          <CompanyName>Pragan Tech Solutions</CompanyName>
          <Tagline>Technology Consulting & Software Development</Tagline>

          <InfoBlock>
            <Label>Office Address</Label>
            <Value>
              First Floor, Pragan Tech Solutions<br />
              Joseph Complex, 1, Xavier's Colony<br />
              Tirunelveli, Tamil Nadu 627005<br />
              India
            </Value>

          </InfoBlock>

          <InfoBlock>
            <Label>Working Hours</Label>
            <Value>
              Monday – Friday<br />
              9:30 AM – 6:30 PM (IST)
            </Value>
          </InfoBlock>

          <InfoBlock>
            <Label>Email</Label>
            <Value>sales@pragantechsolutions.com</Value>
          </InfoBlock>

          <InfoBlock>
            <Label>Location</Label>
            <MapFrame
              src="https://www.google.com/maps?q=Pragan%20Tech%20Solutions,%20Joseph%20Complex,%20Xavier's%20Colony,%20Tirunelveli&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />

          </InfoBlock>

          <PrimaryButton href="https://www.google.com/maps?q=Pragan+Tech+Solutions,+Joseph+Complex,+Xavier's+Colony,+Tirunelveli"
            target="_blank"
            rel="noopener noreferrer"
          >
            Find Us on Google Maps</PrimaryButton>
        </InfoPanel>

        {/* RIGHT FORM PANEL */}
        <FormPanel>
          <TopBadge>CONTACT</TopBadge>

          <Title>
            Let’s Work <span>Together</span>
          </Title>

          <SubTitle>contact@pragantechsolutions.com</SubTitle>

          <Form>
            <FormRow>
              <InputGroup>
                <Label>Full Name *</Label>
                <Input placeholder="Your full name" />
              </InputGroup>

              <InputGroup>
                <Label>Email *</Label>
                <Input placeholder="Your email address" />
              </InputGroup>
            </FormRow>

            <FormRow>
              <InputGroup>
                <Label>Phone (optional)</Label>
                <Input placeholder="Your phone number" />
              </InputGroup>

              <InputGroup>
                <Label>Subject *</Label>
                <Select>
                  <option>Select a subject</option>
                  <option>Project Inquiry</option>
                  <option>Consultation</option>
                  <option>Support</option>
                </Select>
              </InputGroup>
            </FormRow>

            <InputGroup>
              <Label>Your Budget (optional)</Label>
              <Input placeholder="Estimated project budget in Rupees" />
            </InputGroup>

            <InputGroup>
              <Label>Message</Label>
              <Textarea placeholder="Write your message here..." />
            </InputGroup>

            <SubmitButton>SEND MESSAGE</SubmitButton>
          </Form>
        </FormPanel>
      </ContactContainer>
    </PageWrapper>
  );
};

export default ContactUs;
const BRAND = {
  gradient: "linear-gradient(135deg, #ff8a3d, #d55bff)",
  accentOrange: "#ff8a3d",
  accentPurple: "#d55bff",
  softAccent: "rgba(213, 91, 255, 0.15)",
  darkText: "#1a1a1a",
  lightBg: "#fdf7f4",
};


const PageWrapper = styled.div`
  min-height: 100vh;
  background: radial-gradient(circle at top, #fff5ee, #f7f2ff);
  padding: 120px 20px 60px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 600px) {
    padding: 80px 12px 40px;
  }
`;



const ContactContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  background: #ffffff;
  border-radius: 28px;
  display: grid;
  grid-template-columns: 1fr 2fr;
  box-shadow: 0 40px 80px rgba(0,0,0,0.15);
  overflow: hidden;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 600px) {
    border-radius: 18px;
  }
`;


/* LEFT PANEL */

const InfoPanel = styled.div`
  padding: 48px 40px;
  background: ${BRAND.gradient};
  color: white;
  display: flex;
  flex-direction: column;

  @media (max-width: 600px) {
    padding: 32px 22px;
    text-align: center;
  }
`;


const CompanyName = styled.h2`
  font-size: 26px;
  font-weight: 800;
  color: #ffffff;
`;


const Tagline = styled.p`
  font-size: 14px;
  color: rgba(255,255,255,0.8);
  margin-bottom: 40px;
`;

const InfoBlock = styled.div`
  padding: 14px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);

  &:last-child {
    border-bottom: none;
  }
`;


const Label = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.8);
`;


const Value = styled.div`
  font-size: 14px;
  color: white;
  line-height: 1.6;
`;

const MapPlaceholder = styled.div`
  height: 130px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: 1px dashed rgba(255, 255, 255, 0.45);
`;

const PrimaryButton = styled.a`
  margin-top: auto;
  width: 100%;
  background: #ffffff;
  color: ${BRAND.accentPurple};
  border: none;
  padding: 14px;
  border-radius: 999px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #111;
    color: white;
  }
`;
const MapFrame = styled.iframe`
  width: 100%;
  height: 140px;
  border-radius: 14px;
  border: none;
  filter: brightness(0.9) contrast(1.1);

  @media (max-width: 600px) {
    height: 180px;
  }
`;



/* RIGHT PANEL */

const FormPanel = styled.div`
  padding: 50px;

  @media (max-width: 600px) {
    padding: 32px 22px;
  }
`;


const TopBadge = styled.div`
  display: inline-block;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 12px;
  background: rgba(255, 138, 61, 0.12);
  color: ${BRAND.accentOrange};
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 6px;
  background: ${BRAND.gradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 900px) {
    font-size: 28px;
  }
`;

const SubTitle = styled.p`
  margin: 10px 0 30px;
  color: #666;
`;

const Form = styled.form``;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

const InputGroup = styled.div`
  margin-bottom: 22px;
`;

const Input = styled.input`
  width: 100%;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #eee;
  background: #fafafa;

  &:focus {
    outline: none;
    border-color: ${BRAND.accentPurple};
    box-shadow: 0 0 0 3px ${BRAND.softAccent};
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #eee;
  background: #fafafa;
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 14px;
  min-height: 120px;
  border-radius: 12px;
  border: 1px solid #eee;
  background: #fafafa;

  &:focus {
    outline: none;
    border-color: ${BRAND.accentPurple};
    box-shadow: 0 0 0 3px ${BRAND.softAccent};
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  max-width: 220px;
  margin: 24px auto 0;
  padding: 14px 0;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  border-radius: 50px;
  color: #fff;
  border: none;
  cursor: pointer;
  display: block;
  position: relative;
  overflow: hidden;

  background: linear-gradient(135deg, #ff8a3d, #d55bff);
  box-shadow: 
    0 12px 30px rgba(213, 91, 255, 0.35),
    inset 0 1px 1px rgba(255, 255, 255, 0.3);

  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);

  /* Glow layer */
  &::before {
    content: "";
    position: absolute;
    inset: -2px;
    background: linear-gradient(135deg, #ffb27a, #e0a3ff);
    opacity: 0;
    border-radius: 50px;
    z-index: -1;
    transition: opacity 0.35s ease;
    filter: blur(12px);
  }

  &:hover {
   background: linear-gradient(135deg, #d55bff, #ff8a3d);
    box-shadow: 0 18px 40px rgba(213, 91, 255, 0.55);
  }

  &:active {
    transform: scale(0.96);
    box-shadow: 0 8px 18px rgba(213, 91, 255, 0.4);
  }

  @media (min-width: 768px) {
    max-width: 200px;
    padding: 12px 0;
  }
`;

/* ---------------------------------- */

